export class DrippingHelper {
    static normalizeLiberationByQuiz(config) {
        if (!config)
            return null;
        const liberation = config.liberation?.type === 'BY_QUIZ'
            ? {
                ...config.liberation,
                quizId: config.liberation.pageId
            }
            : config.liberation;
        return {
            ...config,
            liberation
        };
    }
    static extractDrippingDataToList(drippingConfigs) {
        const drippingConfigsSize = drippingConfigs?.length ?? 0;
        const rawDrippingConfig = drippingConfigsSize === 1 ? drippingConfigs?.[0] : null;
        const drippingConfig = rawDrippingConfig
            ? DrippingHelper.normalizeLiberationByQuiz(rawDrippingConfig)
            : null;
        return { drippingConfig, drippingConfigsSize };
    }
}
